
import moment from 'moment'

export const InstructorMix = {

	components: {
		
	},
	data(){
		return {
      
			onlyRead: false

		}
	},
	created() {

	},
	methods:{

	}


};